/*global wx*/
import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Tooltip,
    Switch,
    message
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import { FieldTimeOutlined, SearchOutlined, ReloadOutlined, InfoCircleFilled } from '@ant-design/icons'
import moment from 'moment';
import View from '../fangjian/view.js'
import { ReactSVG } from "react-svg";


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
            total: true,
            list2: []
        };
        this.view = React.createRef();
    }

    componentWillMount() {

    }

    componentDidMount() {

        let floor = this.getHashQuery('floor')
        this.getdata(floor)

    }


    getHashQuery = (key) => {
        const hash = window.location.hash;
        const idx = hash.indexOf('?');
        if (idx === -1) return null;
        const queryStr = hash.slice(idx + 1);
        const params = new URLSearchParams(queryStr);
        return params.get(key);
    }

    getdata = (floor) => {
        let that = this
        that.setState({
            tableloading: true
        })
        let arr = {
            floor
        }
        // console.log('token:', this.getHashQuery('token'))
        let url = 'mini/room/map'
        let type = this.getHashQuery('type')
        if(type == 1){
            url = 'mini/room/map2'
        }
        fetch(url, {
            headers: {
                'X-Client-Type': 'mini',
                'Authorization': 'Bearer ' + this.getHashQuery('token')
            },
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                data.data.list = data.data.datalist || []
                that.setState({
                    ...data.data,
                    tableloading: false, // count: Number(data.count)
                })
            })
    }

    arrSVG = (arr) => {
        let _this = this
        if (arr) {
            return arr.map((item, index) => <>
                <div className={'title'} key={'title_' + index}>{item.name}</div>
                <ReactSVG src={item.url}
                    key={'svg_' + index}
                    style={{ width: '100%' }}
                    onClick={(e) => {
                        console.log(e.target.id)
                        // e.target.style.fill = "#217DE2"
                        if (e.target.id && !this.getHashQuery('nonavigate')) {
                            // e.target.style.fill = "#217DE2"
                            _this.state.list.map((item2, index2) => {
                                if (e.target.id == item2.number) {
                                    // 判断是否处在小程序webview环境
                                    console.log('判断是否处在小程序webview环境')
                                    console.log(window.wx, window.wx.miniProgram)
                                    if (window.wx && window.wx.miniProgram) {
                                        wx.miniProgram.navigateTo({ url: '/pages2/index/detail?id=' + item2.id })
                                    } else {
                                        // 本地浏览器调试分支，可以写console或者H5跳转逻辑
                                        console.log('当前不在小程序webview环境，不跳转小程序页面')
                                    }
                                }
                            })
                        }
                    }}
                    afterInjection={(svg) => {
                        // console.log(svg.querySelectorAll('.st2'))
                        let arr = svg.querySelectorAll("rect");
                        let arr2 = svg.querySelectorAll("polygon")
                        arr = [...arr, ...arr2];
                        arr = arr.filter((item) => item.id)
                        // console.log(arr)
                        // return
                        arr.forEach((item2, index2) => {
                            item2.style.fill = "#DFE1E5"
                        })
                        let arr3 = svg.querySelectorAll(".area")
                        arr3.forEach((item2, index2) => {
                            item2.textContent = "待定"
                            // if (item2.id) {
                            //     // console.log('#FF0000')
                            //     item2.style.fill = "#FF0000"
                            // }
                        })
                        console.log(arr3)
                        _this.state.list.map((item2, index2) => {
                            if(this.getHashQuery('room_id')){
                                if (item2.number == this.getHashQuery('room_id')) {
                                    console.log('room_id', item2.number)
                                    // alert('room_id', item2.number)
                                }else{
                                    return
                                }
                            }
                            arr.forEach((item3, index3) => {
                                if (item3.id == item2.number) {
                                    switch (item2.status) {
                                        case 1:
                                            item3.style.fill = "#FF3030"
                                            break;
                                        case 2:
                                            item3.style.fill = "#18AE3E"
                                            break;
                                        case 3:
                                            item3.style.fill = "#217DE2"
                                            break;
                                        case 4:
                                            item3.style.fill = "#F78B37"
                                            break;
                                        case 5:
                                            item3.style.fill = "#7552FF"
                                            break;
                                        default:
                                            item3.style.fill = "#DFE1E5"
                                            break
                                    }
                                    // item3.textContent = "㎡"
                                } else {
                                    // item3.style.fill = "#DFE1E5"
                                }
                            })
                            arr3.forEach((item3, index3) => {
                                if (item3.id == item2.number + '-area') {
                                    let html = `<tspan x="0" dy="0">${item2.area}</tspan>`
                                    if (item2.qyjc) {
                                        html += `<tspan x="${item2.x ? item2.x : 0}" dy="30">${item2.qyjc ? item2.qyjc : ''}</tspan>`
                                    }
                                    if (item2.bz) {
                                        html += `<tspan x="${item2.bzx ? item2.bzx : 0}" dy="30">${item2.bz ? item2.bz : ''}</tspan>`
                                    }
                                    item3.innerHTML = html
                                } else {
                                    // item3.style.fill = "#DFE1E5"
                                }
                            })
                        })
                    }}
                />
            </>)
        }
    }

    chooseld = (yq_id, building) => {
        console.log(yq_id, building)
        let that = this
        let data = Object.assign({}, this.state.newcondition, { yq_id, building })
        that.setState({
            newcondition: data,
            total: false
        })
        setTimeout(() => {
            that.getdata(1)
        })
    }

    render() {
        const { tableloading } = this.state;
        const columns = [
            {
                title: '园区',
                dataIndex: 'yqname',
                // render: (text) => <a>{text}</a>,
                onCell: (record, index) => {
                    return {
                        rowSpan: record.hbnum ? record.hbnum : 0,
                    };
                },
            },
            {
                title: '楼栋',
                dataIndex: 'name',
            },
            {
                title: '层数',
                dataIndex: 'csnum',
            },
            {
                title: '房间数',
                dataIndex: 'fjnum',
            },
            {
                title: '已租房间',
                dataIndex: 'yznum',
            },
            {
                title: '待租房间',
                dataIndex: 'dznum',
            },
            {
                title: '操作',
                dataIndex: 'caozuo',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <a onClick={() => {
                                this.chooseld(record.yq_id, record.id)
                            }}>查看</a>
                        </Space>
                    </>)
                },
            },
        ]
        return (<>
        <style>{`
        #root, body.body, html {
          min-width:unset;
        }
      `}</style>
        <div style={{ padding: 15 }}>
            <Row justify="space-between" align="top" style={{ marginBottom: 15 }}>
                <Space size={30}>
                    <div className={'pms_item i1'}>待租</div>
                    <div className={'pms_item i2'}>已租</div>
                    <div className={'pms_item i3'}>自用</div>
                    <div className={'pms_item i4'}>已预订</div>
                    <div className={'pms_item i5'}>即将到期</div>
                </Space>
            </Row>
            <div className={'pm_list'}>
                {this.state.building_name ?
                    <div style={{ fontSize: 24, fontWeight: 'bold' }}>{this.state.building_name}</div> : null}
                {this.arrSVG(this.state.floor ? [this.state.floor] : [])}
            </div>
        </div>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname} />
